import React from 'react'

import { client } from 'config/routes'

import { DropdownHeader } from './DropdownHeader'

export const OurRecipesDropdown = () => (
  <DropdownHeader
    titleText="our recipes"
    links={[
      { href: client.menu, text: "This Week's Menu" },
      { href: client.cookbookAllRecipes, text: 'All Gousto Recipes' },
    ]}
  />
)
